import styled from 'styled-components';
import { pxToRem, media } from '$util/theme';

export default styled.div`
  font-size: ${pxToRem(18)};
  ${media.up('md')} {
    font-size: ${pxToRem(24)};
  }
  font-weight: 200;
  margin-top: 30px;
  strong {
    font-weight: 600;
  }
  a {
    text-decoration: underline;
  }
`;
